import { Box } from "@mui/material";
import style from "./style.module.scss";
export default function Spinner() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "24px 0" }}>
      <span className={style.loader}></span>
    </Box>
  );
}
